import React from "react";
import { motion } from "framer-motion";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { useI18n } from "@/lib/i18n";
import { TEST_IDS } from "@/constants/testIds";

export default function FAQ() {
    const { t } = useI18n();
    return (
        <section id="faq" className="relative py-24 sm:py-32">
            <div className="mx-auto max-w-4xl px-6 lg:px-10">
                <div className="text-xs uppercase tracking-[0.2em] font-bold text-brand-cyan">FAQ</div>
                <h2 className="mt-3 font-display font-black text-4xl sm:text-5xl tracking-tighter text-white">
                    {t.landing.faqTitle}
                </h2>

                <motion.div
                    initial={{ opacity: 0, y: 12 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.5 }}
                    viewport={{ once: true }}
                    className="mt-10"
                >
                    <Accordion type="single" collapsible className="w-full">
                        {t.landing.faq.map((item) => (
                            <AccordionItem
                                key={item.key}
                                value={item.key}
                                data-testid={TEST_IDS.landing.faqItem(item.key)}
                                className="border-b border-white/8"
                            >
                                <AccordionTrigger className="text-left font-display font-semibold text-lg text-white hover:no-underline py-5">
                                    {item.q}
                                </AccordionTrigger>
                                <AccordionContent className="text-zinc-400 leading-relaxed pb-6">
                                    {item.a}
                                </AccordionContent>
                            </AccordionItem>
                        ))}
                    </Accordion>
                </motion.div>
            </div>
        </section>
    );
}
